var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 1500 1500",
    viewBox: "0 0 1500 1500",
    width: 550,
    height: 550,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.875)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 750,
    r: 540.5,
    fill: "#e0e9f9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    transform: "translate(-23.64 -23.64) scale(.56485)",
    className: "colore0e9f9 svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(15.001 44.73 550.42) scale(.88835)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2373.5,
    cy: 2914.7,
    r: 130.4,
    fill: "#3594dc",
    fillRule: "evenodd",
    clipRule: "evenodd",
    transform: "translate(-865.883 -979.943) scale(.53333)",
    className: "color3594dc svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3594dc",
    fillRule: "evenodd",
    d: "M2778.7,2891.3c0-13.4-42.5-26.2-118.1-35.7c-75.6-9.5-178.2-14.8-285.2-14.8h0 c-107,0-209.6,5.3-285.2,14.8c-75.6,9.5-118.1,22.3-118.1,35.7c0,15.1,0,31.6,0,46.7c0,13.4,42.5,26.2,118.1,35.7 c75.7,9.5,178.2,14.8,285.2,14.8h0c107,0,209.6-5.3,285.2-14.8c75.6-9.5,118.1-22.3,118.1-35.7 C2778.7,2922.9,2778.7,2906.4,2778.7,2891.3z",
    clipRule: "evenodd",
    transform: "matrix(.11433 0 0 .91332 128.42 -2551.18)",
    className: "color3594dc svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4fb4f3",
    fillRule: "evenodd",
    d: "M2812.8,2389.1c0-105.6-36.4-206.9-101.1-281.6c-64.7-74.7-152.5-116.6-244-116.6c0,0,0,0,0,0 c-91.5,0-179.3,42-244,116.6c-64.7,74.7-101.1,176-101.1,281.6v566.3h690.2V2389.1z",
    clipRule: "evenodd",
    transform: "matrix(.53333 0 0 .46216 -916.115 -830.718)",
    className: "color4fb4f3 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3594dc",
    fillRule: "evenodd",
    d: "M2718.6,2709.6l-690.2,32.3v98.9h690.2V2709.6z",
    clipRule: "evenodd",
    transform: "translate(-865.883 -979.943) scale(.53333)",
    className: "color3594dc svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#acdcfa",
    fillRule: "evenodd",
    d: "M2778.7,2914.7c0-19.6-7.8-38.4-21.6-52.2c-13.9-13.8-32.6-21.6-52.2-21.6c-153.5,0-505.5,0-659,0 c-19.6,0-38.4,7.8-52.2,21.6c-13.8,13.9-21.6,32.6-21.6,52.2l0,0c0,19.6,7.8,38.4,21.6,52.2c13.8,13.9,32.6,21.6,52.2,21.6 c153.5,0,505.5,0,659,0c19.6,0,38.4-7.8,52.2-21.6C2770.9,2953,2778.7,2934.2,2778.7,2914.7L2778.7,2914.7z",
    clipRule: "evenodd",
    transform: "translate(-866.865 -1019.33) scale(.53333)",
    className: "coloracdcfa svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3594dc",
    fillRule: "evenodd",
    d: "M2711.4,2231.3c56.7,80.7,78.5,185,51,287.7l-26.6,99.2c-101.2-7.4-181.2-92-181.2-195.1 C2554.6,2328.4,2622,2249.4,2711.4,2231.3z",
    clipRule: "evenodd",
    transform: "translate(-722.252 -833.777) scale(.47379)",
    className: "color3594dc svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.067 33.389)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2723.5,
    cy: 2299.7,
    r: 202.4,
    fill: "#f2763d",
    fillRule: "evenodd",
    clipRule: "evenodd",
    transform: "translate(-852.633 -964.234) scale(.53333)",
    className: "colorf2763d svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed3f07",
    d: "M2771.9,2305.3c0-4.6-0.7-8.1-2-10.6c-1.3-2.5-3.2-3.8-5.7-3.8c-2.4,0-4.3,1.2-5.6,3.8 c-1.3,2.5-1.9,6-1.9,10.6s0.6,8.1,1.9,10.7c1.3,2.5,3.1,3.8,5.6,3.8c2.4,0,4.3-1.3,5.7-3.8 C2771.2,2313.4,2771.9,2309.9,2771.9,2305.3z M2785.2,2305.3c0,4-0.5,7.6-1.6,10.7c-1,3.1-2.5,5.7-4.3,7.9 c-1.9,2.1-4.1,3.7-6.6,4.8c-2.6,1.1-5.4,1.6-8.4,1.6c-3.1,0-5.9-0.5-8.5-1.6c-2.6-1.1-4.8-2.7-6.6-4.8c-1.8-2.1-3.3-4.7-4.3-7.9 c-1-3.1-1.5-6.7-1.5-10.7s0.5-7.6,1.5-10.7c1-3.1,2.5-5.7,4.3-7.8c1.9-2.1,4.1-3.7,6.6-4.8c2.6-1.1,5.4-1.6,8.5-1.6 c3,0,5.8,0.6,8.4,1.6c2.6,1.1,4.8,2.7,6.6,4.8c1.8,2.1,3.3,4.7,4.3,7.8C2784.7,2297.7,2785.2,2301.3,2785.2,2305.3z",
    transform: "translate(-5172.38 -4548.63) scale(2.0901)",
    className: "colored3f07 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2771.9,2305.3c0-4.6-0.7-8.1-2-10.6c-1.3-2.5-3.2-3.8-5.7-3.8c-2.4,0-4.3,1.2-5.6,3.8 c-1.3,2.5-1.9,6-1.9,10.6s0.6,8.1,1.9,10.7c1.3,2.5,3.1,3.8,5.6,3.8c2.4,0,4.3-1.3,5.7-3.8 C2771.2,2313.4,2771.9,2309.9,2771.9,2305.3z M2785.2,2305.3c0,4-0.5,7.6-1.6,10.7c-1,3.1-2.5,5.7-4.3,7.9 c-1.8,2.1-4.1,3.7-6.6,4.8c-2.6,1.1-5.4,1.6-8.4,1.6c-3.1,0-5.9-0.5-8.5-1.6c-2.6-1.1-4.8-2.7-6.6-4.8c-1.8-2.1-3.3-4.7-4.3-7.9 c-1-3.1-1.5-6.7-1.5-10.7s0.5-7.6,1.5-10.7c1-3.1,2.5-5.7,4.3-7.8c1.9-2.1,4.1-3.7,6.6-4.8c2.6-1.1,5.4-1.6,8.5-1.6 c3,0,5.8,0.6,8.4,1.6c2.6,1.1,4.8,2.7,6.6,4.8c1.8,2.1,3.3,4.7,4.3,7.8C2784.7,2297.7,2785.2,2301.3,2785.2,2305.3z",
    transform: "translate(-5177.85 -4558.16) scale(2.0901)",
    className: "colorfff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1247.54 1276.09) scale(.7358)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2763d",
    d: "M3631.3,244.3c-0.5,0-1.1-0.1-1.6-0.2l-97.7-23.7c-3.7-0.9-6-4.6-5.1-8.3c0.9-3.7,4.6-6,8.3-5.1l97.7,23.7 c3.7,0.9,6,4.6,5.1,8.3C3637.2,242.2,3634.4,244.3,3631.3,244.3z",
    transform: "translate(-631.561 -1639.04) scale(.73655)",
    className: "colorf2763d svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2763d",
    d: "M3621.4,260.8c-2.8,0-5.4-1.7-6.4-4.4l-29.7-77.5c-1.4-3.6,0.4-7.5,4-8.9c3.6-1.4,7.5,0.4,8.9,4l29.7,77.5 c1.4,3.6-0.4,7.5-4,8.9C3623.1,260.6,3622.2,260.8,3621.4,260.8z",
    transform: "translate(-533.763 -1735.53) scale(.73655)",
    className: "colorf2763d svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2763d",
    d: "M3631.3,244.3c-1.8,0-3.5-0.7-4.9-2l-92.7-92.7c-2.7-2.7-2.7-7.1,0-9.7c2.7-2.7,7.1-2.7,9.7,0l92.7,92.7 c2.7,2.7,2.7,7.1,0,9.7C3634.8,243.6,3633.1,244.3,3631.3,244.3z",
    transform: "translate(-597.431 -1683.64) scale(.73655)",
    className: "colorf2763d svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBg);
export default __webpack_public_path__ + "static/media/NotificationBg.bcfb7bae37826ed29e4f960ee9c17cd3.svg";
export { ForwardRef as ReactComponent };